import React, { useEffect, useState } from "react";
import {
  
  CModal,
  CModalBody,
} from "@coreui/react";
import { useDispatch } from "react-redux";
import crossButton from "../../../components/assets/image/crossButton.svg";
import "../../../components/common/styles/changePassword.css";
import "../../../components/common/styles/createAdmin.css";
import {  addKeywordRequest } from "../redux/categoryDispatcher";


const AddKeyword = ({
  parentId = 0,
  buttonLabel = "Add Keyword",
  editMode = false,
  categoryData = {},
}) => {
  // console.log("parent id", parentId);
  const dispatch = useDispatch();

  const [isModalVisible, setIsModalVisible] = useState(false); // Local State
 
  const [keyword, setKeyword] = useState("");

const inputRef = React.useRef(null);

useEffect(() => {
  if (isModalVisible) {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 500);
  }
}, [isModalVisible]);


  const resetForm = () => {
    setKeyword("");
  };


  // Handle Add Category Submission
  const handleAddKeyword = () => {
    if (keyword.trim() === "") {
      alert("Please enter keyword");
      return;
    }

    var data = {

      "keyword": keyword,
      "category_id": parentId
    };

    dispatch(addKeywordRequest(data));
    setKeyword("");
     setIsModalVisible(false);
  };

  return (
    <div>
      {/* Button to Open Modal */}
      <button

        onClick={() => {
          if (!editMode) {
            resetForm(); // Reset the form if adding
          }
          setIsModalVisible(true)
          // dispatch(showAddKeywordModal())

        }}
        style={{
          backgroundColor:  "rgb(0 0 0)",
          color: "white",
          border: "none",
          cursor: "pointer",
          borderRadius: "4px",
          fontSize: "14px",
          minWidth: "60px",
          // width: "100%",
          height:  "30px",  // Increased height
          padding:  "4px 10px", // Added padding
          display: "flex",
          alignItems: "center",
          // alignSelf:"end",
          justifyContent: "center",
        }}
      >{buttonLabel}</button>
      {/* <CButton
        className="personal-setting-button button"
        onClick={() => dispatch(showAddCategoryModal())}
      >
        Add Category
      </CButton> */}

      {/* Modal */}
      <CModal
        alignment="center"
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        className="attributemodal"

      >
        <CModalBody className="main-container createAdmin" >
          <div className="main-container createAdmin">
            {/* Close Button */}
            <div className="cross-btn-div d-flex">
              <img
                onClick={() => setIsModalVisible(false)}
                src={crossButton}
                alt="close"
                className="cross-button"
              />
            </div>

            <form onSubmit={(e) => e.preventDefault()} className="login-form">
              <div className="mb-4">
                <h4
                  className="h4 fw-bold"
                  style={{ color: "#007bff", textAlign: "center" }}
                >
                  <b>Add New Keyword</b>
                </h4>
              </div>



              {/* Category Name Input */}
              <div className="mb-3 input-login-box">
                <input
                   ref={inputRef}
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  name="name"
                  type="text"
                  className="form-control login-input"
                  placeholder="Enter Keyword"
                />
              </div>






              {/* Submit Button */}
              <button
                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                type="button"
                onClick={handleAddKeyword}
              >
                Submit
              </button>
            </form>
          </div>
        </CModalBody>
      </CModal>
    </div>
  );
};

export default AddKeyword;
